<template>
  <div class="my-books-container">
    <ListHeader :showSwitch="'paper'" class="books-list-header" @switchDataView="(val) => (dataView = val)" listTitle="我的数字报" @query-list="getBooks"></ListHeader>
    <papers-published ref="papersPublishedRef" :dataView="dataView"></papers-published>
  </div>
</template>

<script>
import PapersPublished from './components/PapersPublished'
import ListHeader from '@components/list/listHeader'
export default {
  name: '',
  data() {
    return {
      dataView: 'chart'
    }
  },
  components: {
    PapersPublished,
    ListHeader
  },
  methods: {
    getBooks(val) {
      this.$refs.papersPublishedRef.searchData = val
      this.$refs.papersPublishedRef.getBooks(1)
      this.$refs.papersPublishedRef.currentPageNo = 1
    }
  }
}
</script>
<style lang="scss">
.my-books-container {
  width: 100%;
  height: 100%;
  padding-left: 18px;
}
</style>
